import { getBytesFromMegabytes } from '../../../../utils/file'

export const QA_NAME_VIEWING_DOCUMENT_UPLOAD_MODAL = 'viewingDocumentUpload'

export const VIEWING_DOCUMENT_MAX_SIZE_MB = 20

export const VIEWING_DOCUMENT_MAX_SIZE = getBytesFromMegabytes(
  VIEWING_DOCUMENT_MAX_SIZE_MB
)

export const VIEWING_DOCUMENT_ACCEPTED_TYPES = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
}
